import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

/**
 * Tela de retorno do Stripe Checkout (cancel_url).
 * Usuário fechou ou cancelou o checkout sem completar o pagamento.
 * A empresa permanece em `pending_checkout` no backend — ele pode
 * tentar novamente a partir do TrialExpiredModal ao logar.
 */
const OnboardingCanceled = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow p-8 text-center">
        <XCircle className="mx-auto mb-4 text-amber-500" size={48} />
        <h1 className="text-xl font-semibold mb-2 text-[#0E0E12]">Checkout não concluído</h1>
        <p className="text-gray-600 mb-6">
          Sem problema, seu cadastro está salvo. Para liberar o acesso, finalize o pagamento quando quiser.
        </p>
        <button
          onClick={() => navigate('/login')}
          className="bg-[#FFC107] hover:bg-[#1A1A20] text-white py-2 px-6 rounded-lg font-semibold transition-colors"
        >
          Voltar ao login
        </button>
        <p className="mt-6 text-sm text-gray-500">
          Dúvidas? <a href="mailto:contato@iatconsulting.com.br" className="text-[#0E0E12] hover:underline">contato@iatconsulting.com.br</a>
        </p>
      </div>
    </div>
  );
};

export default OnboardingCanceled;
